import { useContext } from 'react'
import "../Application/Application.scss"
import Header from "../../Shared-Component/Header/Header"
import Footer from "../../Shared-Component/Footer/Footer"
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import "../AdmissionCommittee/AdmissionCommittee"
import { useEffect } from 'react'
import { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import QRCode from "react-qr-code";
import { BsDownload } from "react-icons/bs";
import { Link } from 'react-router-dom';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "../../CampusLife/CampusSharedComponent/CampusViewMore/CampusViewMore.scss"
import { useRef } from 'react';
import Lines from '../../components/Lines';
import axios from 'axios';
import { AppContext } from '../../context/AppContext';
import { toast } from 'react-toastify';
import SuccessDialog from '../../components/SuccessDialog';


const Application = () => {

    const { backendUrl } = useContext(AppContext);
    const [showContent, setShowContent] = useState(false)
    const [formData, setFormData] = useState({})
    const [isSubmitting, setIsSumitting] = useState(false);
    const [isOpenProgramme, setIsOpenProgramme] = useState()
    const qrData = "https://example.com";
    const [showAlert, setShowAlert] = useState(false);
    const dropdownRef = useRef(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const eMailpattern = /^\S+@\S+\.\S+$/
    const phoneNumberPattern = /^\d{10}$/
    const yearPattern = /^\d{4}$/

    const [applicationFormData, setApplicationFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        programmes: "",
        department: "",
        yearOfPassing: "",
        parentName: "",
        address: "",
        transactionId: ""
    });

    const [errors, setErrors] = useState({})
    const handleChange = (e) => {
        e.preventDefault()
        let { name, value } = e.target;
        if (name === "yearOfPassing") {
            value = parseInt(value) || 0;
        }
        if (name === "programmes") {
            value = value.name;
        }

        if (name === "department") {
            value = value.name;
        }
        setApplicationFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));

    };

    const programmes = [
        { name: "UG" },
        { name: "PG" }
    ];
    const UGProgrammes = [
        { name: "B.Sc Biotechnology" },
        { name: "B.Sc Hotel Management & Catering Science" },
        { name: "BBA (*AICTE)" },
        { name: "B.C.A (*AICTE)" },
        { name: "B.Sc Computer Science" },
        { name: "B.Sc Information Technology" },
        { name: "B.Sc Nutrition & Dietetics" },
        { name: "B.A English" },
        { name: "B.Com" },
        { name: "Ai and data science" },
        { name: "B.Sc Microbiology" },
        { name: "B.Sc Visual Communication" },
    ];

    const PGProgrammes = [
        { name: "M.Sc Biotechnology" },
        { name: "M.Sc Computer Science" },
        { name: "M.Sc Mathematics" },
        { name: "M.A English" },
        { name: "M.Com" },
    ];

    const validateForm = () => {
        const testeMailPattern = eMailpattern.test(applicationFormData.email)
        const testPhoneNumber = phoneNumberPattern.test(applicationFormData.phoneNumber)
        const testYearPattern = yearPattern.test(applicationFormData.yearOfPassing)
        const currentyear = new Date().getFullYear()
        const error = {};
        if (!applicationFormData.name.trim()) {
            error.name = "Required"
        }
        if (!applicationFormData.email.trim()) {
            error.email = "Required"
        }
        else if (!testeMailPattern) {
            error.email = "Invalid Pattern"
        }
        else {

        }
        if (!applicationFormData.phoneNumber.trim()) {
            error.phoneNumber = "Required"
        }
        else if (!testPhoneNumber) {
            error.phoneNumber = "InValid Pattern"
        }
        else {

        }
        if (!applicationFormData.programmes) {
            error.programmes = "Required"
        }
        if (!applicationFormData.department) {
            error.department = "Required"
        }
        if (!applicationFormData.yearOfPassing) {
            error.yearOfPassing = "Required"
        }
        else if (!testYearPattern) {
            error.yearOfPassing = "InValid Pattern"
        }
        else if (applicationFormData.yearOfPassing < 1900 || applicationFormData.yearOfPassing > new Date().getFullYear()) {
            error.yearOfPassing = `Enter year between 1900 and ${currentyear}.`
        }
        else {

        }
        if (!applicationFormData.parentName.trim()) {
            error.parentName = "Required"
        }
        if (!applicationFormData.address.trim()) {
            error.address = "Required"
        }
        if (!applicationFormData.transactionId.trim()) {
            error.transactionId = "Required"
        }
        setErrors(error)
        return Object.keys(error).length === 0;
    }

    const clearForm = () => {
        setApplicationFormData({
            name: "",
            email: "",
            phoneNumber: "",
            programmes: "",
            department: "",
            yearOfPassing: "",
            parentName: "",
            address: "",
            transactionId: ""
        })
        setErrors({})
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            console.log('Form validation failed - showing errors');
            return; 
        }

        setIsSumitting(true);

        try {
            console.log('Submitting application data:', applicationFormData);
            const res = await axios.post(`${backendUrl}/api/auth/submitApplicationForm`, applicationFormData)

            console.log('Response received:', res.data);
            const submittedData = { ...applicationFormData };
            setFormData({ ...submittedData })

            if (res.data.success === true) {
                setShowSuccessDialog(true);
                clearForm();
            }
        }
        catch (error) {
            console.error('Full error:', error);
            console.error('Error response:', error.response);

            if (error.response) {
                if (error.response.status === 503) {
                    toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                }
                else if (error.response.status === 500) {
                    toast.error("Internal Server Error")
                    clearForm();
                }
                else if (error.response.status === 400) {
                    toast.error("Validation error: " + (error.response.data?.message || 'Please check your input'));
                }
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }
            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        } finally {
            setIsSumitting(false);
        }
    }

    const handleDownloadForm = (e) => {
        e.preventDefault()
        const programmeName = formData?.programmes;
        let filePath = "#";
        if (programmeName === "UG") {
            filePath = "/UGAdmissionForm.pdf";
        } else if (programmeName === "PG") {
            filePath = "/PGAdmissionForm.pdf";
        }
        if (filePath !== "#") {
            const link = document.createElement("a");
            link.href = filePath;
            link.setAttribute("download", "AdmissionForm.pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => {
                setShowAlert(true)
            }, 1000);
        }
        setFormData({})
    };

    useEffect(() => {
        const AdmissionApplicationPadding = (isOpenProgramme) => {
            const dropDownPanel = document.querySelector(".p-dropdown-panel")
            const parentLabel = document.querySelector(".parent-label")
            const departmentLabel = document.querySelector(".department-label")
            if (dropDownPanel && !departmentLabel) {
                let panelHeight = dropDownPanel.offsetHeight;
                let panelPadding = parseInt(window.getComputedStyle(dropDownPanel).paddingTop) || 0;
                panelHeight += panelPadding;
                if (parentLabel) {
                    parentLabel.style.paddingTop = `${panelHeight}px`;
                }
            }
            if (dropDownPanel && departmentLabel) {
                let panelHeight = dropDownPanel.offsetHeight;
                let panelPadding = parseInt(window.getComputedStyle(dropDownPanel).paddingTop) || 0;
                panelHeight += panelPadding;
                parentLabel.style.paddingTop = `${panelHeight}px`;
                dropDownPanel.style.zIndex = '-3000';
            }
            if (!dropDownPanel) {
                let panelHeight = 10;
                if (parentLabel) {
                    parentLabel.style.paddingTop = `${panelHeight}px`;
                }
                if (departmentLabel) {
                    departmentLabel.style.paddingTop = `${panelHeight}px`;
                }
            }
        }
        AdmissionApplicationPadding(isOpenProgramme)
        window.addEventListener("load", AdmissionApplicationPadding);
        window.addEventListener("resize", AdmissionApplicationPadding);
    })

    return (
        <>
            {/* Header */}
            <div className="header">
                <Header />
            </div>

            <SuccessDialog
                visible={showSuccessDialog}
                onHide={() => setShowSuccessDialog(false)}
                header="Application Submitted"
                message="Your admission application has been submitted successfully!"
                buttonLabel="OK"
            />

            {/* Content */}
            <div className='main-container application-wrapper'>
                <div className="admissionPageMainContainer main-content">
                    <header className="applicationPageHeader">
                        <h2 style={{ color: "#116C4A" }}>Application For Admission</h2>
                        <span className="lines-parent">
                            <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                        </span>
                    </header>
                    <p className='comm-content'>Noorul Islam College of Arts & Science invites applications from eligible candidates for admission into its Undergraduate (UG) and Postgraduate (PG) programs for the academic year [2025-2026]. The college offers a wide range of courses across Arts, Science, Commerce, and Computer Applications streams, aimed at nurturing academic excellence and holistic development.
                        <ul style={{ paddingLeft: "10px" }}>
                            <li>Candidates must have passed the Higher Secondary (10+2) examination conducted by the Tamil Nadu State Board or an equivalent recognized board.</li>
                            <li>For Course-specific eligibility, download a prospectus.</li>
                            <li>Download UG or PG application form through online payment of Rs 150/- by online or using QR Code.</li>
                        </ul>

                    </p>
                    <div className='ad-app-form-container'>
                        <div className='ad-app-form-subcontainer'>
                            <div className='ad-app-form'>
                                <h2>Admission Form :</h2>
                                <form>
                                    <div className="inputLabelParent">
                                        <label>Name :</label>
                                        <InputText name='name'
                                            className="inputField"
                                            value={applicationFormData.name}
                                            onChange={handleChange}
                                            placeholder="Enter Your Name"
                                            invalid={!!errors.name}

                                        />
                                        {
                                            errors.name &&
                                            <p className='form-error'>{errors.name}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label >E-mail :</label>
                                        <InputText
                                            className="inputField"
                                            name='email'
                                            value={applicationFormData.email}
                                            onChange={handleChange}
                                            placeholder="Enter Your Email"
                                            invalid={!!errors.email}
                                        />
                                        {
                                            errors.email &&
                                            <p className='form-error'>{errors.email}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label>Phone No :</label>
                                        <InputText
                                            className="inputField"
                                            name='phoneNumber'
                                            value={applicationFormData.phoneNumber}
                                            onChange={handleChange}
                                            placeholder="Enter 10 digit number"
                                            invalid={!!errors.phoneNumber}
                                            maxLength={10}
                                            keyfilter="int"
                                        />
                                        {
                                            errors.phoneNumber &&
                                            <p className='form-error'>{errors.phoneNumber}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label>Programmes<span className='programmes-span'>*</span></label>
                                        <div className='ad-app-form-dropdown'>
                                            <Dropdown
                                                ref={dropdownRef}
                                                className="ad-app-dropdown-options"
                                                name='programmes'
                                                value={programmes.find(p => p.name === applicationFormData.programmes)}
                                                onChange={handleChange}
                                                options={programmes}
                                                optionLabel="name"
                                                placeholder="Choose a Programme"
                                                checkmark={false}
                                                highlightOnSelect={false}
                                                onShow={() => setIsOpenProgramme(true)}
                                                onHide={() => setIsOpenProgramme(false)}
                                                appendTo="self"
                                                invalid={!!errors.programmes}
                                            />
                                        </div>
                                        {
                                            errors.programmes &&
                                            <p className='form-error'>{errors.programmes}</p>
                                        }

                                    </div> {
                                        (applicationFormData.programmes) &&
                                        <div style={{ display: "flex", width: "100%", flexDirection: "column", gap: "clamp(7.6px, 1.9vw, 14.25px)" }}>
                                            <label className='department-label'>Department :</label>
                                            <div className='ad-app-form-dropdown'>
                                                <Dropdown
                                                    className="ad-app-dropdown-options"
                                                    name='department'
                                                    onChange={handleChange}
                                                    options={applicationFormData.programmes === "UG" ? UGProgrammes : PGProgrammes}
                                                    optionLabel="name"
                                                    placeholder="Choose a Department"
                                                    value={applicationFormData.programmes === "UG" ? UGProgrammes.find(p => p.name === applicationFormData.department) : PGProgrammes.find(p => p.name === applicationFormData.department)}
                                                    checkmark={false}
                                                    appendTo="self"
                                                    highlightOnSelect={false}
                                                    onShow={() => setIsOpenProgramme(true)}
                                                    onHide={() => setIsOpenProgramme(false)}
                                                    invalid={!!errors.department}
                                                />
                                            </div>
                                            {
                                                errors.department &&
                                                <p className='form-error'>{errors.department}</p>
                                            }
                                        </div>
                                    }
                                    <div className="inputLabelParent">
                                        <label className='parent-label'>Year of Passing :</label>
                                        <InputText
                                            className="inputField"
                                            name='yearOfPassing'
                                            value={applicationFormData.yearOfPassing}
                                            onChange={handleChange}
                                            placeholder="Year Of Passing(YYYY)"
                                            invalid={!!errors.yearOfPassing}
                                            keyfilter="int"
                                        />
                                        {
                                            errors.yearOfPassing &&
                                            <p className='form-error'>{errors.yearOfPassing}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label className='parent-label'>Parent's Name :</label>
                                        <InputText
                                            className="inputField"
                                            name='parentName'
                                            value={applicationFormData.parentName}
                                            onChange={handleChange}
                                            placeholder="Enter Your Parent's Name"
                                            invalid={!!errors.parentName}
                                        />
                                        {
                                            errors.parentName &&
                                            <p className='form-error'>{errors.parentName}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label>Address :</label>
                                        <InputText
                                            className="inputField"
                                            name='address'
                                            value={applicationFormData.address}
                                            onChange={handleChange}
                                            placeholder="Enter Your Address"
                                            invalid={!!errors.address}
                                        />
                                        {
                                            errors.address &&
                                            <p className='form-error'>{errors.address}</p>
                                        }
                                    </div>
                                    <div className="inputLabelParent">
                                        <label>Transaction Id :</label>
                                        <InputText
                                            className="inputField"
                                            name='transactionId'
                                            value={applicationFormData.transactionId}
                                            onChange={handleChange}
                                            placeholder="Enter Your Transaction Id"
                                            invalid={!!errors.transactionId}
                                        />
                                        {
                                            errors.transactionId &&
                                            <p className='form-error'>{errors.transactionId}</p>
                                        }
                                    </div>
                                    <div className='ad-app-submit-container'>
                                        <Button
                                            label={isSubmitting ? "Submitting..." : "Submit"}
                                            icon={isSubmitting ? "pi pi-spin pi-spinner" : null}
                                            disabled={isSubmitting}
                                            className='ad-app-submit'
                                            onClick={(e) => handleSubmit(e)}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className='ad-app-form-subcontainer' >
                            <div className='ad-app-bank-data' >
                                <h2>Bank Details</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <div className="firstColumn">
                                                <td>Name Of The Account</td>
                                                <td className="colon">:</td>
                                            </div>
                                            <div className="secondColumn">

                                                <td>Noorul Islam College of Arts & Science</td>
                                            </div>
                                        </tr>
                                        <tr>
                                            <div className="firstColumn">
                                                <td>Bank Name</td>
                                                <td className="colon">:</td>
                                            </div>
                                            <div className="secondColumn">

                                                <td>Tamilnad Mercantile Bank</td>
                                            </div>
                                        </tr>
                                        <tr>
                                            <div className="firstColumn">
                                                <td>Branch</td>
                                                <td className="colon">:</td>
                                            </div>
                                            <div className="secondColumn">

                                                <td>Thalakulam</td>
                                            </div>
                                        </tr>
                                        <tr>
                                            <div className="firstColumn">
                                                <td>Account Number</td>
                                                <td className="colon">:</td>
                                            </div>
                                            <div className="secondColumn">

                                                <td>026150050304783</td>
                                            </div>
                                        </tr>
                                        <tr>
                                            <div className="firstColumn">
                                                <td>IFSC code</td>
                                                <td className="colon">:</td>
                                            </div>
                                            <div className="secondColumn">

                                                <td>TMBL0000026</td>
                                            </div>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div className='qrcode-container'>
                                <div className='qrcode-subcontainer'>
                                    <div className="corner top-left"></div>
                                    <div className="corner top-right"></div>
                                    <div className='qr-code'>
                                        {/* <QRCode value={qrData} className='qr-code' /> */}
                                        <h2 className="qr-code"> QR code </h2>
                                    </div>
                                    <div className="corner bottom-left"></div>
                                    <div className="corner bottom-right"></div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "clamp(10px, 2.5vw, 25px)" }}>
                                    <h2>Scan QR Code</h2>
                                    <p>For Payment</p>
                                </div>
                            </div>
                            <div className='applicationformdownload-container'>
                                <div className='applicationformdownload-subcontainer' onClick={(formData?.programmes === "UG" || formData?.programmes === "PG") ? handleDownloadForm : undefined} style={{
                                    backgroundColor: (formData?.programmes === "UG" || formData?.programmes === "PG") ? "rgb(98, 96, 96)" : " #A4A4A4",
                                    cursor: (formData?.programmes === "UG" || formData?.programmes === "PG")
                                        ? "pointer"
                                        : "not-allowed",
                                    pointerEvents: (formData?.programmes === "UG" || formData?.programmes === "PG")
                                        ? "auto"
                                        : "none"
                                }}>
                                    <div><Link><BsDownload className='formdownload-icon' /></Link></div>
                                    <div><p className='formdownload-label'>Application Form</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showAlert && (
                        <div className="alert-overlay">
                            <div className="alert-box">
                                <p>Form Downloaded Successfully</p>
                                <button onClick={() => setShowAlert(false)}>OK</button>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <Footer />

                </div>
            </div>
        </>
    )
}

export default Application